export default __webpack_public_path__ + "static/mob-banner-76918a9d9b0141cae0de9611998c7a49.png";